import { useQuery } from "@tanstack/react-query";
import { getUserQualifications } from "../api/userQualification.api";
import { UserQualificationRow } from "../api/userQualification.type";
import { useUserDetails } from "./useUserDetails";

function useLoadUserQualifications(userId?: string) {
  const { userDetails } = useUserDetails();

  const {
    data: qualifications = [],
    isLoading,
    error,
  } = useQuery<UserQualificationRow[]>({
    queryKey: ["userQualifications", userId || userDetails?.id],
    queryFn: () => getUserQualifications(userId || userDetails?.id),
    enabled: !!(userId || userDetails?.id),
  });

  return { qualifications, isLoading, error };
}

export default useLoadUserQualifications;

